/* unplugin-vue-components disabled */import __unplugin_components_3 from '~icons/ep/arrow-down-bold';
import { ElIcon as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_1 from '~icons/ep/arrow-up-bold';
import { ElFormItem as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "flex items-center"
};
const _hoisted_2 = {
  key: 0
};
export default /*#__PURE__*/_defineComponent({
  props: {
    confList: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const isShow = ref(false);
    const handleMore = () => {
      isShow.value = !isShow.value;
    };
    return (_ctx, _cache) => {
      const _component_el_form_item = __unplugin_components_0;
      const _component_i_ep_ArrowUpBold = __unplugin_components_1;
      const _component_el_icon = __unplugin_components_2;
      const _component_i_ep_ArrowDownBold = __unplugin_components_3;
      return _openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.confList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [index === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form_item, {
          label: item.name
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.value), 1)]),
          _: 2
        }, 1032, ["label"]), __props.confList.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [isShow.value ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          class: "cp marginB20 marginL20",
          color: "blue",
          onClick: handleMore
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_ArrowUpBold)]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          class: "cp marginB20 marginL20",
          color: "blue",
          onClick: handleMore
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_ArrowDownBold)]),
          _: 1
        }))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), isShow.value && index !== 0 ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 1,
          label: item.name
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.value), 1)]),
          _: 2
        }, 1032, ["label"])) : _createCommentVNode("", true)]);
      }), 128);
    };
  }
});